import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import "./Conocenos.css";

import { ReactComponent as TituloConocenos } from "../../assets/home/conecta-peru-center.svg";

import nosotrosSvg from "../../assets/generales/conocenospersona.jpg";
import misionSvg from "../../assets/conocenos/mision.svg";
import visionSvg from "../../assets/conocenos/vision.svg";

const Conocenos = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 100);
      }
    }
  }, [location]);

  return (
    <div className="conocenos-page">
      <section className="conocenos-content-section">
        <div className="row g-4">
          <div className="col-lg-6 col-md-6 col-12 order-lg-1 order-2">
            <img
              src={nosotrosSvg}
              alt="Nosotros en Conéctate Perú"
              className="nosotros-image"
            />
          </div>

          <div className="col-lg-6 col-md-6 col-12 order-lg-2 order-1">
            <section className="conocenos-intro-section container">
              <div className="row justify-content-center">
                <div className="col-lg-11 col-md-11 col-12 text-center">
                  <div className="conocenos-title-wrapper mb-4">
                    <TituloConocenos className="conocenos-main-title img-fluid" />
                  </div>
                  {/* Texto descriptivo */}
                  <p className="conocenos-description">
                    Nuestro propósito es brindarte un espacio de conexión y
                    encuentro con personas de intereses similares, donde podrás
                    participar en todo tipo de eventos y actividades, nutrir tu
                    talento literario, aprender un nuevo idioma o practicar tu
                    deporte favorito, las posibilidades son infinitas. Aquí
                    fomentamos la diversidad y la conexión entre todo tipo de
                    personas, y todo esto en un espacio seguro y de bienestar.
                    <br />
                    <br />
                    Unirte a nuestra comunidad es simple, todo lo que necesitas
                    es registrarte en nuestra web, explorar los grupos
                    disponibles y empezar a participar en actividades que más te
                    interesen. Además si tienes una idea para un grupo o evento,
                    puedes crearlo fácilmente y nosotros te ayudaremos a
                    encontrar participantes adecuados.
                  </p>
                </div>
              </div>
            </section>

            {/* Sección para Misión y Visión - seccionan separadamente */}
            <section className="conocenos-sections-wrapper pb-5" id="mision">
              <div className="row justify-content-center">
                <div className="col-lg-11 col-md-11 col-12">
                  {/* Misión */}
                  <div className="conocenos-card">
                    <h3 className="conocenos-heading">Misión</h3>
                    <div className="row">
                      <div className="col-lg-6">
                        <p className="conocenos-description">
                          Conéctate Perú, es creado para convertirse en un
                          referente nacional para unir personas con intereses
                          comunes y nuestra plataforma adopta esta idea
                          innovadora con un enfoque inclusivo y dinámico.
                          Nuestra misión principal es ser el puente que conecte
                          personas, proyectos y comunidades. Creemos firmemente
                          que cada persona tiene el poder de enriquecer su vida
                          social y profesional al interactuar con otras personas
                          que comparten los mismos objetivos y aspiraciones.
                        </p>
                      </div>
                      <div className="col-lg-6">
                        <img
                          src={misionSvg}
                          className="img_conten"
                          alt="Mision"
                        />
                        <p className="conocenos-description">
                          En nuestra plataforma ofrecemos herramientas
                          accesibles y efectivas, que facilitan la creación de
                          grupos y la organización de eventos de manera ágil y
                          segura. En esta plataforma fomentamos conexiones
                          reales y significativas; diseñado para la diversidad e
                          inclusión.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* Visión */}
                  <div className="conocenos-card" id="vision">
                    <div className="row">
                      <div className="col-lg-6">&nbsp;</div>
                      <div className="col-lg-6">
                        <h3 className="conocenos-heading">Visión</h3>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-6 order-md-2 order-2">
                        <img
                          src={visionSvg}
                          className="img_conten"
                          alt="Visión"
                        />
                      </div>
                      <div className="col-lg-6 order-md-2 order-1">
                        <p className="conocenos-description">
                          Nuestra visión es ser la plataforma líder en conectar
                          personas y comunidades de todo el país. Visualizamos
                          en ser un referente para la creación de redes
                          culturales, sociales y profesionales, impulsando el
                          crecimiento personal, la colaboración y la innovación;
                          con un enfoque inclusivo y tecnológico. Buscamos
                          construir un mundo más conectado, unido y lleno de
                          oportunidades para todos.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Conocenos;
